// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 618) return "static/chunks/618-df8e2bb2718ede91.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"146":"datadog_browser_logs","340":"layout__client_site_chrome_ui","367":"layout__minimal","748":"datadog_browser_rum"}[chunkId] || chunkId) + "." + {"146":"f3abe889bd8da3f1","205":"2e90144ef4045da8","319":"0cbc2894a3f1b950","340":"255951d46ec3159b","367":"ec068fcaf0ca5cff","639":"145d8b82eb19365e","748":"7cecab087088ae42"}[chunkId] + ".js";
};